import { useState } from 'react'

export default function TrekOverview({ trek }) {
  const [expanded, setExpanded] = useState(false)

  return (
    <div style={{ marginBottom: '48px' }}>
      <h2 className="section-title" style={{ fontSize: '26px', marginBottom: '16px' }}>Trip overview.</h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: 'var(--ink-mid)', fontWeight: 300 }}>
        {trek.description} {trek.tagline}
        {expanded && trek.overviewExtra && <>{' '}{trek.overviewExtra}</>}
      </p>
      {trek.overviewExtra && (
        <button
          onClick={() => setExpanded(e => !e)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--green)', fontSize: '13px', fontWeight: 600, marginTop: '8px', padding: 0 }}
        >
          {expanded ? 'Read less' : 'Read more'}
        </button>
      )}
    </div>
  )
}
